export const CUSTOM_LOOP_START_NODE = 'custom-loop-start'
